var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { Editor } from "slate";
var findOriginalId = function (editor) {
    var selection = editor.selection;
    var _a = __read(Array.from(Editor.nodes(editor, {
        at: Editor.unhangRange(editor, selection),
        match: function (n, path) {
            return !Editor.isEditor(n) && path.length === 1;
        },
    })), 1), match = _a[0];
    var id = match[0].id;
    return !!match && id;
};
export var addAnchor = function (props) {
    var _a = props.anchorData, editor = _a.editor, id = _a.id, type = _a.type;
    var _b = props.anchorOperations, addToList = _b.addToList, removeFromList = _b.removeFromList;
    var selection = editor.selection;
    // const isCollapsed = selection && Range.isCollapsed(selection);
    if (!selection)
        return false;
    if (selection.anchor.path[0] !== selection.focus.path[0]) {
        return;
    }
    var originalId = findOriginalId(editor);
    console.log("originalId", originalId);
    console.log("newId", id);
    console.log(selection.anchor.path);
    console.log(selection.focus.path);
    var order = selection.anchor.path[0];
    if (type === "heading-one") {
        addToList({ id: id, type: type, order: order, name: type + "-" + order });
    }
    else if (type === "heading-two") {
        removeFromList(originalId);
        addToList({ id: id, type: type, order: order, name: type + "-" + order });
    }
    else {
        removeFromList(originalId);
    }
};
